import { ErrorIcon, SuccessIcon } from '@shared/assets/icons';
import { typography } from '@shared/tokens/typography.stylex';
import { Modal, Button } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { createPortal } from 'react-dom';
import { styles } from './styles';

interface CreateFreelanceResultModalProps {
  status: string;
  onClose?: () => void;
}

export const CreateFreelanceResultModal = ({ status, onClose }: CreateFreelanceResultModalProps) => {
  const handleClose = () => {
    onClose?.();
  };

  if (!status) return null;

  return createPortal(
    <Modal
      active
      settingsHeader={{ height: '16px', padding: '0px' }}
      settingsContainer={{
        height: 'auto',
        width: '480px',
        padding: '0 24px',
      }}
      settingsFooter={{ height: '16px', padding: '0px' }}
    >
      <div {...stylex.props(styles.container)}>
        <p {...stylex.props(styles.header)}>
          {status === 'success' ? 'Редактирование внештатного участника' : 'Ошибка'}
        </p>
        <div {...stylex.props(styles.info)}>
          <div {...stylex.props(styles.icon)}>{status === 'success' ? <SuccessIcon /> : <ErrorIcon />}</div>
          <p {...stylex.props(styles.description)}>
            {status === 'success'
              ? 'Данные участника успешно отредактированы'
              : 'При редактировании данных участника, произошла непредвиденная ошибка. Повторите попытку позднее'}
          </p>
        </div>
        <div {...stylex.props(styles.action)}>
          <Button
            onClick={handleClose}
            variant="accent"
            size="medium"
            settings={{ height: '36px', width: '118px', fontSize: typography['fontSizeCaption-1'] }}
          >
            Подтвердить
          </Button>
        </div>
      </div>
    </Modal>,
    document.getElementById('modal') as Element
  );
};
